// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_ij-0";
export var actionModalContentContainer = "_ij-1";
export var createTagButton = "_ij-2";
export var footerContainer = "_ij-7";
export var fullWidthDivider = "_ij-3";
export var hasCreateTagButton = "_ij-4";
export var noCreateTagButton = "_ij-5";
export var tagsContainer = "_ij-6";
export var tagsModalContentContainer = "_ij-8";